<template>
  <layout-main-inner title="用户反馈">
    <layout-card-wrap :hasHeaderSlot="userPermission.SUPERVISE"
      v-loading="loading">
      <template slot="form">
        <assign-ent-select v-if="userPermission.SUPERVISE"
          immediate
          v-model="config.vendorId"
          style="margin-right: 10px"
          :option="{}"
          :callback="() => {handleCurrentChange(1)}" />
      </template>
      <el-table border
        stripe
        :data="list">
        <el-table-column label="商品名称">
          <template slot-scope="{row}">
            {{row.productName}}<span v-if="row.productNameRemark">({{row.productNameRemark}})</span>
          </template>
        </el-table-column>
        <el-table-column label="企业名称"
          v-if="userPermission.SUPERVISE"
          prop="vendorName">
        </el-table-column>
        <el-table-column label="标签信息"
          width="270">
          <template slot-scope="{row}">
            <div>标签码：{{row.tagCode}}</div>
            <div>标签序号：{{row.formartedTagNo}}</div>
            <div>批次号：{{row.batchCode}}</div>
          </template>
        </el-table-column>
        <el-table-column label="联系方式"
          prop="contact"
          width="120">
        </el-table-column>
        <el-table-column label="反馈内容"
          prop="content"
          width="200">
        </el-table-column>
        <el-table-column label="反馈时间"
          width="140">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat()}}
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
          @current-change="handleCurrentChange"
          :current-page.sync="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import AssignEntSelect from '@/components/business/assign-ent-select.vue'
export default {
  name: 'product-list',
  components: { AssignEntSelect },
  data () {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productName: '',
        status: 2,
        vendorId: null
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.dispatch('scantag/getfeedbacks', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
